import React from 'react'

function Social() {
  return (
    <div className='bbox' id='social'>
        <div id='social-wrap'>
            <h2 className='sbox-title'>SOCIALS</h2>
            <div id='soc-tb'>
                <h3>
                    <a target="_blank" href="https://www.linkedin.com/in/jordan-zabinski/" rel="noreferrer">
                      <i class="fa-brands fa-linkedin"></i>
                      LinkedIn
                    </a>
                  </h3>
                  <h3>
                    <a target="_blank" href="https://github.com/jzab6367" rel="noreferrer">
                      <i class="fa-brands fa-github"></i>
                      GitHub
                    </a>
                  </h3>
                  {/* <h3>???</h3> */}
                  <h3>
                    <a
                      target="_blank"
                      href="https://www.instagram.com/jordanzabinskii/" rel="noreferrer">
                      <i class="fa-brands fa-square-instagram"></i>
                      Instagram
                    </a>
                  </h3>
            </div>
        </div>
    </div>
  )
}

export default Social

